module.exports = __webpack_public_path__ + "img/idpw.bdfbcec5.png";